import produce from 'immer';

import { defaultProcessingState } from '../utils';

import { USER_DOCUMENT_SIGN_START, USER_DOCUMENT_SIGN_FULFILL, USER_DOCUMENT_SIGN_REJECT } from './user.actions';

const defaultState = {
  document: {
    sign: defaultProcessingState(),
  },
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case USER_DOCUMENT_SIGN_START: {
      ++draft.document.sign.processing;
      return draft;
    }

    case USER_DOCUMENT_SIGN_FULFILL: {
      --draft.document.sign.processing;
      draft.document.sign.error = null;
      return draft;
    }

    case USER_DOCUMENT_SIGN_REJECT: {
      --draft.document.sign.processing;
      draft.document.sign.error = action.payload;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
